import { render, staticRenderFns } from "./Planpage.vue?vue&type=template&id=2039ac53&scoped=true"
import script from "./Planpage.vue?vue&type=script&lang=js"
export * from "./Planpage.vue?vue&type=script&lang=js"
import style0 from "./Planpage.vue?vue&type=style&index=0&id=2039ac53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039ac53",
  null
  
)

export default component.exports